'use client';

import useSWR from 'swr';
import { getLocaleInfo } from '@/utils/helpers';
import { StartingKit } from './useStartingKit';
import { API_URLS } from '@/lib/api/config';
import useFeature from './useFeature';
import { postFetcher } from '@/components/subflow-v3/context/SubFlowV3Context';
import useLocale from './useLocale';

export interface BundleDiscount {
  uuid: string;
  anchor: string;
  name: string;
  size: number;
  amount: number;
  discount_value: number;
  discounted_amount: number;
  with_addons: {
    addons_amount: number;
    amount: number;
    discount_value: number;
    discounted_addons_amount: number;
    discounted_amount: number;
  };
}

export interface BundleDiscountPreview {
  bundle_discount_preview: {
    bundles: BundleDiscount[];
  };
}

export const useBundleDiscountPreview = (startingKit?: StartingKit) => {
  const language = useLocale();
  const localeInfo = getLocaleInfo(language);
  const isBfcm2024 = useFeature('money_enable-bfcm-2024');

  const body = {
    bundle_discount_preview: {
      starting_kit_anchor: startingKit?.anchor,
      currency_code: localeInfo.currencyCode.toLowerCase(),
      language,
    },
  };

  // Avoid calling the API if the flag is not enabled
  const hasFullPayload = isBfcm2024 && startingKit?.anchor && language;

  return useSWR<BundleDiscountPreview>(
    hasFullPayload
      ? [
          `${API_URLS.PRODUCT_CATALOG_PROXY}/bundle_discount_previews`,
          JSON.stringify(body),
        ]
      : null,
    postFetcher,
    {
      revalidateOnFocus: false,
    },
  );
};
